import totalOffsetTop from "../helpers/totalOffsetTop";
import headerShrink from "../helpers/headerShrink";

const FOCUSABLE_SELECTOR =
  "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), input:not([type=hidden]):enabled, select:enabled, textarea:enabled";

class PdpLifestyleHero extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      if (!event.target.closest("[data-shop-now]")) return;

      event.preventDefault();
      this.shopNow();
    });
  }

  connectedCallback() {
    this.section.setAttribute("data-attributes-only", "");
  }

  shopNow() {
    this.scrollPastSection();
    this.focusProductForm();
  }

  get section() {
    return this.closest(".shopify-section") || this;
  }

  scrollPastSection() {
    const header = document.querySelector("sticky-header");
    const headerHeight = header?.getBoundingClientRect().height || 0;
    const shrink = headerShrink();
    const sectionBottom =
      totalOffsetTop(this.section) + this.section.offsetHeight;

    window.scroll({
      top: Math.max(sectionBottom - headerHeight + shrink, 0),
      behavior: "smooth",
    });
  }

  focusProductForm() {
    const form =
      document.querySelector(".main-product__form") ||
      document.querySelector("product-form");

    const target = [...(form?.querySelectorAll(FOCUSABLE_SELECTOR) || [])].find(
      (el) => el.offsetParent !== null,
    );

    target?.focus({ preventScroll: true });
  }
}

if (!customElements.get("pdp-lifestyle-hero")) {
  customElements.define("pdp-lifestyle-hero", PdpLifestyleHero);
}
